import React from 'react'
import './Footer.css';
import logo from '../../assets/logo.png';
import facebook from '../../assets/facebook_icon.png'
import twitter from '../../assets/twitter_icon.png'
import linkedin from '../../assets/linkedin_icon.png'
import { Link } from 'react-router-dom';
function Footer() {
  return (
    <footer id='footer'>
        <div className='container'>
            <div className='row'>
                <div className='col-5'>
                    <img style={{width:"100px"}} src={logo} alt='logo'/>
                    <p>Craving something delicious? We’ve got you covered! With fast, reliable delivery and a wide selection of mouthwatering dishes from your favorite local restaurants, getting your next meal has never been easier. Order now and experience the convenience of food delivered exactly when you need it.</p>
                    <div className='d-flex gap-4'>
                        <div><img src={facebook} alt='facebook icon'/></div>
                        <div><img src={twitter} alt='twiiter icon'/></div>
                        <div><img src={linkedin} alt='linkedin icon'/></div>
                    </div>
                </div>
                <div className='col-4'>
                    <div className='text-white'>
                    <h4>Company</h4>
                    <ul className=' text-white'>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/">About</Link></li>
                        <li><Link to="/">Delivery</Link></li>
                        <li><Link to="/">Privacy Policy</Link></li>
                    </ul>
                    </div>
                </div>
                <div className='col-3'>
                    <div className='text-white'>
                    <h4>Get In Touch</h4>
                    <address>
                        <ul>
                            <li>+91-98905115</li>
                            <li>contact@tomato.com</li>
                        </ul>
                    </address>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer